import React, { useRef, useState, useEffect } from 'react';
import Carousel from 'react-elastic-carousel';
import Image from 'next/future/image';

const HomeConferences = ({ data }) => {
  const catouselRefSM = useRef();
  const catouselRefMD = useRef();
  const catouselRefLG = useRef();
  const [resetTimeout, setResetTimeout] = useState(null);

  const onNextStart = (currentItem, nextItem, element) => {
    if (currentItem.index === nextItem.index) {
      element.current.goTo(0);
    }
  };

  const onPrevStart = (currentItem, nextItem, element) => {
    if (currentItem.index === nextItem.index) {
      element.current.goTo(data.length);
    }
  };

  useEffect(() => {
    // Clear the timeout when the component unmounts
    return () => clearTimeout(resetTimeout);
  }, [resetTimeout]);

  const awardCard = (data, index) => (
    <a
      href={data.event_url}
      key={index}
      className="conference-card my-4 d-flex justify-content-center flex-column position-relative"
      target="_blank"
    >
      <Image src={data.event_logo} alt={`${data.event_name} Event Hosted by KonfHub`} fill />
    </a>
  );

  return (
    <>
      <div className="conference-container py-md-3 px-md-4 py-5 px-2">
        <div className="row g-0">
          <div className="col py-md-5">
            <div className="conference-title text-center">
              <span className="theme-text">Conferences</span> Hosted on Us
            </div>
            <div className="conference-sub-title text-center">
              Used by large conferences, active meetups and buzzing communities
            </div>
          </div>
        </div>
        <div className="row g-0 py-3 mt-3 px-md-5 py-md-0 pb-md-5">
          <div className="col d-none d-md-none d-lg-block">
            <Carousel
              ref={catouselRefLG}
              itemsToShow={5}
              isLTR={true}
              enableAutoPlay={true}
              autoPlaySpeed={3000}
              onNextEnd={({ index }) => {
                clearTimeout(resetTimeout);
                setResetTimeout(
                  setTimeout(() => {
                    catouselRefLG.current.goTo(0);
                  }, 4000)
                );
              }} 
              onNextStart={(currentItem, nextItem) => onNextStart(currentItem, nextItem, catouselRefLG)}
              onPrevStart={(currentItem, nextItem) => onPrevStart(currentItem, nextItem, catouselRefLG)}
              disableArrowsOnEnd={false}
              disableArrowsOnStart={false}
            >
              {data.map(awardCard)}
            </Carousel>
          </div>

          <div className="col d-none d-md-block d-lg-none">
            <Carousel
              ref={catouselRefMD}
              itemsToShow={3}
              isLTR={true}
              enableAutoPlay={true}
              autoPlaySpeed={3000}
              onNextEnd={({ index }) => {
                clearTimeout(resetTimeout);
                setResetTimeout(
                  setTimeout(() => {
                    catouselRefMD.current.goTo(0);
                  }, 4000)
                );
              }}
              onNextStart={(currentItem, nextItem) => onNextStart(currentItem, nextItem, catouselRefMD)}
              onPrevStart={(currentItem, nextItem) => onPrevStart(currentItem, nextItem, catouselRefMD)}
              disableArrowsOnEnd={false}
              disableArrowsOnStart={false}
            >
              {data.map(awardCard)}
            </Carousel>
          </div>
          <div className="col d-block d-md-none">
            <Carousel
              ref={catouselRefSM}
              itemsToShow={1}
              isLTR={true}
              enableAutoPlay={true}
              autoPlaySpeed={3000}
              onNextEnd={({ index }) => {
                clearTimeout(resetTimeout);
                setResetTimeout(
                  setTimeout(() => {
                    catouselRefSM.current.goTo(0);
                  }, 4000)
                );
              }}
              onNextStart={(currentItem, nextItem) => onNextStart(currentItem, nextItem, catouselRefSM)}
              onPrevStart={(currentItem, nextItem) => onPrevStart(currentItem, nextItem, catouselRefSM)}
              disableArrowsOnEnd={false}
              disableArrowsOnStart={false}
            >
              {data.map(awardCard)}
            </Carousel>
          </div>
        </div>
      </div>
      <style>{`
      .conference-container {
    background: #F6F9FC;
}

.conference-container .conference-title {
    color: #572148;
    font-weight: 700;
    font-size: 50px;
    font-family: "Nunito";
}

.conference-container .conference-title .theme-text {
    color: #FB5850;
}

.conference-container .conference-sub-title {
    font-family: 'Nunito';
    font-weight: 400;
    font-size: 22px;
    color: #636363;
}

.conference-card{
    background: #23313E;
    border: 4px solid #FFFFFF;
    box-shadow: 3px 3px 20px rgba(0, 0, 0, 0.25);
    border-radius: 0.5px;
    width: 229px;
    height: 118px;
}

.conference-card img{
    width: 100%; /* or any custom size */
    height: 100%;
    object-fit: contain;
}


/* SM screens */
@media only screen and (min-width: 480px) and (max-width: 768px) {
    .conference-container .conference-title {
        font-size: 30px;
    }

    .conference-container .conference-sub-title {
        font-size: 16px;
    }
}

/* XS screens */
@media only screen and (max-width: 480px) {
    .conference-container .conference-title {
        font-size: 30px;
    }

    .conference-container .conference-sub-title {
        font-size: 16px;
    }
}
      `}</style>
    </>
  );
};

export default HomeConferences;